<!-- HEADING PART -->
<p-card>
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12 createnewbtn">
      <div class="text-end p-0 border-round-sm font-bold">
        <p-button (click)="show('Add Subvertical','')" pTooltip="Add {{this.subverticalLabelName}}" tooltipPosition="left"
          styleClass="customAdd p-button-sm p-button-raised mr-4" icon="fa fa-plus"></p-button>
        <button class="fa fa-question helpicon" pTooltip="Help"
          (click)="PagehelpmodalService.openhelpmodal(ref,dialogService,'Help','22')" tooltipPosition="bottom"
          aria-hidden="true"></button>
      </div>
    </div>
  </div>
  <div class=" mr-0 tablehiegt" *ngIf="tableData.length>0">
    <p-table #dt [value]="tableData" [rows]="rowsize" [scrollable]="true" scrollDirection="horizontal"
      scrollHeight="{{commonScrollHeight}}" [resizableColumns]="true" columnResizeMode="expand"
      [first]="currentPageIndex"  [customSort]="true"
      (sortFunction)="this.utilityservice.customSort($event)" 
      [globalFilterFields]="['subverticalid','subverticalname','name','createdon','createdby']"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      (onPage)="handlePageChange($event)" [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true"
      [showCurrentPageReport]="true" paginatorLocale="fa-IR" [paginator]="tableData.length>0" [sortField]="sortfield"
      responsiveLayout="scroll">
      <!-- search -->
      <ng-template pTemplate="caption">
        <div class="grid table-header">
          <div class="col-12 lg:col-10 md:col-10 sm:col-12">
            <span class=" p-input-icon-lft">
              <i icon="pi pi-search"></i>
              <input class="form-control" pInputText type="text" id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains')" placeholder="Search in {{this.subverticalLabelName}}"
                class="tablesearch" pTooltip="Enter Search Criteria" tooltipPosition="top" />
            </span>
          </div>
          <div class="col-12 lg:col-2 md:col-2 sm:col-12 ">
            <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" style="cursor: pointer;"
              (click)="exceldownloadModal=true"></div>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th style=" width: 5px !important;">Action</th>
          <ng-container *ngFor="let col of _selectedColumns">
            <th pResizableColumn [pSortableColumn]="col.field" *ngIf="col.isChecked">{{col.header}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
              <p-columnFilter type="text" [field]="col.field" display="menu"></p-columnFilter>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data>
        <tr>
          <td style="width: 5px !important;">
            <div style="display: flex; gap: 0px;">
              <span class="actionItm" pTooltip="Modify" tooltipPosition="left"> <i class="fa fa-edit"
                  (click)="show('Modify Subvertical',data)"></i></span>
            </div>
          </td>
          <ng-container *ngFor="let col of _selectedColumns">
            <td *ngIf="col.isChecked" [style.width]="col.width" [class]="col.class">
              <span *ngIf="col.field!=='activeflag'" pTooltip=" {{data[col.field] }}"> {{data[col.field] }}</span>
              <span *ngIf="col.field=='activeflag'">
                <i *ngIf="data[col.field]=== 'Y'" pTooltip="Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: green;"></i>
                <i *ngIf="data[col.field]!== 'Y'" pTooltip="Not Active" tooltipPosition="left" class="fa fa-flag"
                  aria-hidden="true" style="color: red;"></i>
              </span>
            </td>
          </ng-container>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="card" style="margin-top: -4px;" *ngIf="tableData.length==0">
    <p-card>
      <p style="text-align: center;">No Data Found...</p>
    </p-card>
  </div>
</p-card>



<p-dialog header="Excel Download" [(visible)]="exceldownloadModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="true" [resizable]="false" position="center">
  <div class="dialog-content-min-excel" style=" text-align: center !important;">
    <div class="card">
      <p>{{excel_paragraph}}</p>
    </div>
  </div>

  <div class="custom-dialog-footer">
    <p-button class="m-1 w-full" label="Close" styleClass="customeclose" (click)="exceldownloadModal=false"></p-button>
    <p-button class="m-1 w-full" label="Download" styleClass="customesave" (click)="subverticalDataExcel()"></p-button>
  </div>
</p-dialog>